/**
 * QR device adoption — the /admin/enrollments/* endpoints.
 *
 * These are owner self-service: the gateway maps the `enrollments` resource to the
 * caller's `company:{id}` domain from the X-Company-Id header (platform admin, with
 * no header, is checked in `system`). So both calls send X-Company-Id via
 * requestControl(). The gateway ALSO pins the adopted company (body.company_id) to
 * that same header, so we send the active company in both places — a mismatch is a
 * 403. approveEnrollment always sends demo_days: 0 (the workspace takes the
 * service-default demo; 0 means "unset" to the license service).
 */
import {requestControl} from '@/shared/api';
import type {ApproveResult, EnrollmentCard} from '@/entities/enrollment/types';

export function fetchEnrollment(
  pairingCode: string,
  companyId: string,
): Promise<EnrollmentCard> {
  return requestControl<EnrollmentCard>(
    `/admin/enrollments/${encodeURIComponent(pairingCode)}`,
    companyId,
  );
}

export type ApproveEnrollmentParams = {
  companyId: string;
  deviceName: string;
  departmentId?: string; // optional: scope a desktop to this department at onboarding
};

export function approveEnrollment(
  pairingCode: string,
  params: ApproveEnrollmentParams,
): Promise<ApproveResult> {
  return requestControl<ApproveResult>(
    `/admin/enrollments/${encodeURIComponent(pairingCode)}/approve`,
    params.companyId,
    {
      method: 'POST',
      body: JSON.stringify({
        company_id: params.companyId,
        device_name: params.deviceName,
        department_id: params.departmentId,
      }),
    },
  );
}
